import { create } from 'zustand';

export const useBiaImpactConfigurationStore = create((set, get) => ({
    configuration: null,
    loading: false,
    error: null,
    isEditing: false,
    lastUpdated: null,

    setConfiguration: (configuration) => set({ configuration }),
    setLoading: (loading) => set({ loading }),
    setError: (error) => set({ error }),
    setIsEditing: (isEditing) => set({ isEditing }),
    setLastUpdated: (lastUpdated) => set({ lastUpdated }),
    reset: () => set({
        configuration: null,
        loading: false,
        error: null,
        isEditing: false,
        lastUpdated: null,
    }),

    fetchConfiguration: async () => {
        const { biaImpactConfigurationIntegration } = await import('@/lib/api/client');
        return biaImpactConfigurationIntegration.fetchConfiguration();
    },

    startEditing: () => set({ isEditing: true }),
    cancelEditing: () => set({ isEditing: false }),

    updateLocalConfiguration: (patch) => {
        const current = get().configuration;
        if (current) {
            set({ configuration: { ...current, ...patch } });
        }
    },

    updateLocalField: (field, value) => {
        const current = get().configuration;
        if (current) {
            set({ configuration: { ...current, [field]: value } });
        }
    },
}));

export default useBiaImpactConfigurationStore;
